import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { CountryRepository } from '@app/domain/ports/country.repository';
import { Country } from '@app/domain/models/country.model';

const MOCK_LATENCY_MS = 300;

/**
 * Subconjunto de países para desarrollo/pruebas sin descargar el asset real.
 * Simula la latencia de red para reproducir condiciones realistas.
 */
const MOCK_COUNTRIES: Country[] = [
  { name: 'Mexico', svg: 'https://flagcdn.com/mx.svg', dialCode: '+52', code: 'MX' },
  { name: 'United States', svg: 'https://flagcdn.com/us.svg', dialCode: '+1', code: 'US' },
  { name: 'Colombia', svg: 'https://flagcdn.com/co.svg', dialCode: '+57', code: 'CO' },
  { name: 'Argentina', svg: 'https://flagcdn.com/ar.svg', dialCode: '+54', code: 'AR' },
  { name: 'Spain', svg: 'https://flagcdn.com/es.svg', dialCode: '+34', code: 'ES' },
  { name: 'Brazil', svg: 'https://flagcdn.com/br.svg', dialCode: '+55', code: 'BR' },
];

@Injectable()
export class CountryMockDataSource extends CountryRepository {
  getCountries(): Observable<Country[]> {
    return of(MOCK_COUNTRIES).pipe(delay(MOCK_LATENCY_MS));
  }
}
